/*eslint-disable*/
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';

// actions
import { gatewayRequestAxios } from '../../services/interceptor'
import { GATEWAY_API_USER_ACTIVITIES_URL } from '../../constants/urls'
import { removeEmptyProperties } from "../../helpers/general";

const initialState = {
    status: 'idle',
    error: null,
    userActivities: [], // array of objects, each object represents a single bulk upload req + status associated w/ user
}

const getParamsForUserActivities = filters => {
  const params = removeEmptyProperties(filters);
  dayjs.extend(utc)
  params.startTime = dayjs.utc(params.startTime).unix()
  params.endTime = dayjs.utc(params.endTime).unix()
  // params.startTime = dayjs(params.startTime).unix()
  // params.endTime = dayjs(params.endTime).unix()
  return params
}

export const getUserActivities = createAsyncThunk('userActivities/getUserActivities', async(filters) => {
    const response = await gatewayRequestAxios.get(GATEWAY_API_USER_ACTIVITIES_URL,  {
      params: getParamsForUserActivities(filters),
    })
    return response.data
})

export const userActivitiesSlice = createSlice({
    name: 'userActivities',
    initialState,
    
    reducers: {
      resetUserActivities: (state) => {
        state.userActivities = []
      },
    },
    extraReducers(builder) {
      builder
        .addCase(getUserActivities.pending, (state) => {
          state.status = 'loading'
          state.error = undefined
        })
        .addCase(getUserActivities.fulfilled, (state, action) => {
          state.status = 'succeeded'
          state.error = undefined
          state.userActivities = action.payload
        })
        .addCase(getUserActivities.rejected, (state, action) => {
          state.status = 'failed'
          state.error = action.error.message
        })
    }
  })

  export const { resetUserActivities } = userActivitiesSlice.actions

  export default userActivitiesSlice.reducer;

